import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import Lightbox from "stimulus-lightbox"

const application = Application.start()
const context = require.context(".", true, /\.js$/)
application.load(definitionsFromContext(context))
application.register("lightbox", Lightbox)